module.exports = __webpack_public_path__ + "img/brackets-plus.3eb04a91.svg";